import React from "react";
import { Box, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import CivixButton from "../ui/CivixButton";
import { FONT_PRIMARY, FONT_WEIGHT } from "../../theme/fonts";

const CHECK_REGISTRATION_URL = "https://www.vote.org/am-i-registered-to-vote/";
const REGISTER_TO_VOTE_URL = "https://www.vote.org/register-to-vote/";

const BANNER_BUTTON_SX = {
  minHeight: 44,
  px: 2.25,
  fontSize: 13,
  fontWeight: FONT_WEIGHT.bold,
  borderRadius: "10px",
};

/** Full-width voter readiness strip under the home nav. */
export default function VoterRollsBanner() {
  return (
    <Box
      component="aside"
      aria-label="Voter registration"
      sx={{
        width: "100%",
        bgcolor: "#064e3b",
        backgroundImage:
          "linear-gradient(90deg, #052e26 0%, #064e3b 40%, #065f46 100%)",
        borderBottom: "1px solid rgba(255, 255, 255, 0.12)",
        px: { xs: 2, md: 3 },
        py: { xs: 1.75, md: 1.5 },
      }}
    >
      <Box
        sx={{
          maxWidth: 1400,
          mx: "auto",
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          alignItems: { xs: "stretch", md: "center" },
          justifyContent: "center",
          gap: { xs: 1.5, md: 3 },
        }}
      >
        <Typography
          component="p"
          sx={{
            fontFamily: FONT_PRIMARY,
            fontWeight: FONT_WEIGHT.semibold,
            fontSize: { xs: 15, md: 16 },
            lineHeight: 1.4,
            color: "#ffffff",
            textAlign: { xs: "center", md: "left" },
            flexShrink: 0,
          }}
        >
          Confirm your voter registration before Election Day.
        </Typography>

        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            gap: 1.25,
          }}
        >
          <CivixButton
            component="a"
            href={CHECK_REGISTRATION_URL}
            target="_blank"
            rel="noopener noreferrer"
            label="Check Voter Registration"
            size="sm"
            variant="primary"
            sx={BANNER_BUTTON_SX}
          />
          <CivixButton
            component="a"
            href={REGISTER_TO_VOTE_URL}
            target="_blank"
            rel="noopener noreferrer"
            label="Register to Vote"
            size="sm"
            variant="primary"
            sx={BANNER_BUTTON_SX}
          />
          <CivixButton
            component={RouterLink}
            to="/elections"
            label="Election Lookup"
            size="sm"
            variant="primary"
            sx={BANNER_BUTTON_SX}
          />
        </Box>
      </Box>
    </Box>
  );
}
